var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c(
        "div",
        {
          staticClass: "main label-divider",
          class: _vm.addMarginTop ? "padding-top" : ""
        },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.label)),
            _vm.required
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("span", [_vm._v(" ")]),
            _c(
              "span",
              { attrs: { slot: "label" }, slot: "label" },
              [
                _vm.tooltip
                  ? _c(
                      "el-tooltip",
                      { attrs: { effect: "light", placement: "bottom" } },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _c("p", {
                              domProps: { innerHTML: _vm._s(_vm.tooltip) }
                            })
                          ]
                        ),
                        _c("i", { staticClass: "el-icon-info" })
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _c("div", { staticClass: "btn-action" }, [_vm._t("actionButton")], 2)
        ]
      ),
      _c("div", { staticClass: "divider" }),
      _vm._t("body")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fbc37e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fbc37e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppDivider.vue
// module id = null
// module chunks = 